
export function scrollToTop() {
    window.scrollTo(0, 0);
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/utils/global-utils.ts